import React, { Component } from 'react'
import PropTypes            from 'prop-types'
import './index.less'

class MajorItem extends Component {

  static contextTypes = {
    history: PropTypes.object,
  }

  static propTypes = {
    major: PropTypes.object,
    onClick: PropTypes.func,
    rightIcon: PropTypes.func,
  }

  handleClick(major) {
    const { onClick ,classifyId} = this.props
    typeof onClick === 'function'
      ? onClick(major,classifyId)
      : this.context.history.push(`/major/detail/${major.id}}`)
  }

  render() {
    const { major, rightIcon } = this.props
    return <div className="major-item" onClick={this.handleClick.bind(this, major)}>
      <span>{major.isArtExam&&<span className='art-icon'>艺考</span>}{major.name}</span>
      {rightIcon
        ? rightIcon(major)
        : <svg className="icon icon-indicator_3"><use xlinkHref="#icon-indicator_3"/></svg>
      }
    </div>
  }
}

MajorItem.defaultProps = {
  major: {},
}

export default MajorItem



// WEBPACK FOOTER //
// ./src/components/MajorItem/indexNew.js